import { useEffect } from "react";

import { useAuthProvider } from "2g-auth";
import { useIntlLang } from "2g-intl";
import { isNotEmpty } from "2g-utils-common";
import { LANGUAGE } from "2g-i18n";
import { useDidUpdateEffect } from "2g-hooks";

import { useUpdateUserLang } from "b2b/api/hooks";

export default function useUserInfoLang() {
  const { userInfo } = useAuthProvider();
  const { lang, setLang } = useIntlLang({ defaultLocale: LANGUAGE.CZECH });
  const updateUserLang = useUpdateUserLang();

  useDidUpdateEffect(() => {
    updateUserLang(lang);
  }, [lang]);

  useEffect(() => {
    if (isNotEmpty(userInfo?.jazyk?.locale)) {
      setLang(userInfo.jazyk.locale);
    }
  }, [userInfo?.jazyk?.locale]);
}
